import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import RegisterApi from '../api/registerApi';

const REGISTER_LOGS_KEY = 'registerLogs';

export const useRegisterLogs = () => {
  return useQuery({
    queryKey: [REGISTER_LOGS_KEY],
    queryFn: async () => {
      const queryStr = toDataSourceRequestString({ skip: 0, take: 0 });
      const response = await RegisterApi.getRegisterLogs(queryStr);
      const payload = response.data || {};
      return {
        data: payload.data || [],
        total: payload.total || 0,
      };
    },
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
  });
};

export const useInvalidateRegisterLogs = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [REGISTER_LOGS_KEY] });
};

// Optimistically remove rows by registerLogId from the cached data.
// Use this after successful delete so the UI updates instantly without
// waiting for the background refetch.
export const useRemoveFromRegisterLogsCache = () => {
  const queryClient = useQueryClient();
  return (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return;
    const idSet = new Set(ids);
    queryClient.setQueryData([REGISTER_LOGS_KEY], (old) => {
      if (!old) return old;
      const remaining = (old.data || []).filter((d) => !idSet.has(d.registerLogId));
      const removed = (old.data || []).length - remaining.length;
      return {
        ...old,
        data: remaining,
        total: Math.max(0, (old.total || 0) - removed),
      };
    });
  };
};
